import { render } from "./KPIPeriodMulti.vue?vue&type=template&id=6ca55b30"
import script from "./KPIPeriodMulti.vue?vue&type=script&lang=js"
export * from "./KPIPeriodMulti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__